export default __webpack_public_path__ + "static/arguably-the-best-face-masks-for-a-long-haul-flight-coconut-oil-46f2074549c20ac97553f1c4a5c5d642.jpg";